import { render, staticRenderFns } from "./concat.vue?vue&type=template&id=6715dd40"
import script from "./concat.vue?vue&type=script&lang=js"
export * from "./concat.vue?vue&type=script&lang=js"
import style0 from "./concat.vue?vue&type=style&index=0&id=6715dd40&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports